import { render, staticRenderFns } from "./setRole.vue?vue&type=template&id=c1b235da&scoped=true"
import script from "./setRole.vue?vue&type=script&lang=js"
export * from "./setRole.vue?vue&type=script&lang=js"
import style0 from "./setRole.vue?vue&type=style&index=0&id=c1b235da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b235da",
  null
  
)

export default component.exports